import { FC } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import { Heading, PromoBannerV2, SpacingToken, Text } from "@livechat/design-system-react-components";

import upgradeMacrosPrivate from "assets/img/macros-promo/upgradeMacrosPrivate@2x.png";
import upgradeMacrosShared from "assets/img/macros-promo/upgradeMacrosShared@2x.png";
import Block from "components/layout/Block";
import { getNextPlanHash } from "helpers/subscription-plans";
import { AgentsRoutes } from "routes/agents/constants";
import { SubscriptionRoutes } from "routes/subscription";
import { selectCurrentSubscriptionPlan } from "store/entities/subscriptions";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

interface IProps {
  isSharedMacro: boolean;
  isAdmin: boolean;
  maxSharedMacros: number;
  maxPrivateMacrosPerAgent: number;
}

const MacroLimitReachedBanner: FC<IProps> = ({ isAdmin, isSharedMacro, maxSharedMacros, maxPrivateMacrosPerAgent }) => {
  const history = useHistory();
  const currentPlan = useSelector(selectCurrentSubscriptionPlan);

  return (
    <Block marginBottom={withVar(SpacingToken.Spacing6)}>
      <PromoBannerV2
        primaryButton={{
          label: isAdmin ? "Upgrade plan" : "Find admin",
          handleClick: () =>
            history.push(isAdmin ? `${SubscriptionRoutes.Plans}/${getNextPlanHash(currentPlan)}` : AgentsRoutes.Agents),
        }}
        additionalContent={<img src={isSharedMacro ? upgradeMacrosShared : upgradeMacrosPrivate} alt="Upgrade" />}
      >
        <Heading as="div" size="lg">
          {isSharedMacro ? "Unlock more shared macros!" : "Unlock more private macros!"}
        </Heading>
        <Text>
          {isSharedMacro &&
            isAdmin &&
            `You've reached your limit of ${maxSharedMacros} shared ${plural(
              maxPrivateMacrosPerAgent,
              "macro",
              "macros"
            )} within your current plan. To continue automating messaging and updating tickets as you go, consider upgrading your subscription.`}
          {!isSharedMacro &&
            isAdmin &&
            `You've reached your limit of ${maxPrivateMacrosPerAgent} private ${plural(
              maxPrivateMacrosPerAgent,
              "macro",
              "macros"
            )} within your current plan. To continue automating messaging and updating tickets as you go, consider upgrading your subscription.`}
          {!isSharedMacro &&
            !isAdmin &&
            `You've reached your limit of ${maxPrivateMacrosPerAgent} private ${plural(
              maxPrivateMacrosPerAgent,
              "macro",
              "macros"
            )} within the current plan. To continue automating messaging and updating tickets as you go, ask any admin to consider upgrading the subscription.`}
        </Text>
      </PromoBannerV2>
    </Block>
  );
};

export { MacroLimitReachedBanner };
